<template>
    <!-- 86bcfa7n0: Experian's identity questions inside the report's steps. -->
    <report-layout
        :report="report"
        :identity-verified="identity_verified"
        current-step="verify_identity"
    >
        <questions-form
            :questions="questions"
            submit-route="reports.verify-identity.questions.submit"
            :submit-params="report.id"
            :cancel-href="route('reports.dashboard', report.id)"
        />
    </report-layout>
</template>

<script>
import ReportLayout from './ReportLayout.vue'
import QuestionsForm from '@/Components/ExperianVerification/QuestionsForm.vue'

export default {
    components: {
        ReportLayout,
        QuestionsForm,
    },
    props: {
        report: Object,
        questions: Object,
        identity_verified: { type: Boolean, default: false },
    },
}
</script>
